<template>
  <div>
    <div id="image-tab-list" class="image-tab-list align-items-center flex-wrap gap-1 " style="position: relative;">
      <div class="d-flex flex-wrap">
        <div v-for="(image, index) in this.images" :key="index" class="div_img">
          <div :style="{ backgroundImage: 'url(' + image.thumb + ')' }"
            style="width: 87px; height: 87px;border: 1px solid #ccc" @click="openGallery(index)"
            class="vib-thumbnail-image relative">
          </div>

          <slot v-if="image.msgType === 'chat.video.msg'" name="videoIcon">
            <VideoIcon />
          </slot>
          <input v-if="showCK" type="checkbox" @click="selectImage(image)"
            style="z-index: 1; margin-top: 5px; margin-left: -85px; position: absolute;" />
          <el-dropdown v-if="showPopup">
            <el-button class="btn_dro"
              style="z-index: 1; margin-top: -85px; margin-left: -30px; position: absolute; width: 22px; height: 22px; padding: 0px;">
              <i class="el-icon-more"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" style="margin-top: -55px;">
              <el-dropdown-item trigger="click">
                <p @click="dowload1Image(image.thumb)">Tải xuống</p>
              </el-dropdown-item>
              <el-dropdown-item trigger="click">
                <p @click="checkboxOpen()">Chọn nhiều</p>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <scroll-loader :key="conversation.id" :loader-method="getDetailLibs" :loader-disable="noMore" style="padding: 0px;">
      <div v-loading="false"></div>
    </scroll-loader>

    <LightBox ref="lightbox" :media="this.images" :show-caption="true" :show-light-box="false" />
    <div class="d-flex" v-if="showCK" style="height: 50px; border-top: 1px solid #dcdbdb;">
      <p class="col-7" style="margin: 10px 10px; font-weight: bold; margin-top: 13px;"> 
        <span style="color: rgb(23, 23, 216);">{{  selectedImages.length}}</span> 
      hình ảnh</p>
      <div class="col-2" style="margin-top: 12px;">
        <el-tooltip effect="dark" content="Tải ảnh về máy"
                  placement="top">
        <el-button @click="dowloadImage()" size="medium" style="margin: auto; padding: 5px;" icon="el-icon-download" circle></el-button>
        </el-tooltip>
      </div>
        
      <p class="col-3" @click="closeCheckbox()" style="margin: 10px 10px; font-weight: bold; margin-top: 13px; cursor: pointer;">Hủy</p>
      
    </div>
  </div>
</template>
<style>
.btn_dro {
  display: none;
}

.div_img:hover .btn_dro {
  display: block;
}

.div_img:hover .vib-thumbnail-image {
  filter: brightness(0.5);
}
</style>
<script>
import LightBox from "../common/LightBox/LightBox";
import VideoIcon from "../common/LightBox/VideoIcon";
import { COMMON } from "../../lib/Common";

export default {
  components: {
    LightBox,
    VideoIcon,
  },
  props: ["conversation", "accountId"],
  data() {
    return {
      noMore: false,
      images: [],
      ts: "",
      pageSize: 40,
      selectedImages: [],
      show: false,
      showCK: false,
      showPopup: true,
    };
  },

  methods: {
    closeCheckbox(){
      this.showCK = false;
      this.showPopup = true;
      const imageDiv = document.querySelector(".image-tab-list");
      imageDiv.style.height = "604px";
    },
    checkboxOpen() {
      this.showCK = true;
      this.showPopup = false;
      const imageDiv = document.querySelector(".image-tab-list");
      imageDiv.style.height = "550px";
    },
    selectImage(image) {
      if (this.selectedImages.includes(image)) {
        this.selectedImages.splice(this.selectedImages.indexOf(image), 1);
      } else {
        this.selectedImages.push(image);
      }
      setTimeout(() => {
        this.show = this.selectedImages.length > 0;
      }, 200);
    },
    dowload1Image(url){

        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const objectUrl = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = url;
            document.body.appendChild(link);
            link.click();

            URL.revokeObjectURL(objectUrl);
            this.alert("success", "Bạn đã tải ảnh thành công");
          });
    },
    dowloadImage() {
      let count = 0;
      this.selectedImages.forEach(item => {
        fetch(item.src)
          .then(response => response.blob())
          .then(blob => {
            const objectUrl = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = item.src;
            document.body.appendChild(link);
            link.click();

            URL.revokeObjectURL(objectUrl);

          });
          count++;
      })
      if(count>0) this.alert("success", "Bạn đã tải "+ count+" ảnh thành công");

      this.showCK = false;
      this.showPopup = true;
      const imageDiv = document.querySelector(".image-tab-list");
      imageDiv.style.height = "604px";
      
    },
    findUrlHDIfExist(row) {
      try {
        let linkHD = JSON.parse(row.params).hd;
        if (linkHD !== null && linkHD !== undefined) {
          return linkHD;
        } else {
          return row.href;
        }
      } catch (e) {
        return row.href;
      }
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    },

    convertData(resp = []) {
      return resp.reduce((obj, item) => {
        let data = {};
        let row = JSON.parse(item.content);
        data.thumb = row.thumb;
        data.ts = item.ts;
        if (item.msgType === COMMON.CHAT_PHOTO) {
          data.src = this.findUrlHDIfExist(row);
          data.msgType = COMMON.CHAT_PHOTO;
          return [...obj, data];
        }
        if (item.msgType === COMMON.CHAT_VIDEO) {
          data.msgType = COMMON.CHAT_VIDEO;
          data.sources = [];
          let srcVideo = {};
          srcVideo.src = this.findUrlHDIfExist(row);
          srcVideo.type = row.type !== "" ? row.type : "video/mp4";
          data.sources.push(srcVideo);
          data.type = "video";
          let params = JSON.parse(row.params);
          data.width = params.video_width;
          data.height = params.video_height;
          data.autoplay = false;
          return [...obj, data];
        }
      }, []);
    },

    getDetailLibs() {
      let request = {
        conversationId: this.conversation.id,
        accountId: this.conversation.accountId,
        timestamp: this.images.length > 0 ? this.images[this.images.length - 1].ts : "",
        msgTypes: [COMMON.CHAT_PHOTO, COMMON.CHAT_VIDEO],
        pageSize: this.pageSize
      };
      this.$http.post("/api/message/filter", request).then(resp => {
        this.images = this.images.concat(this.convertData(resp.data));
        if (resp.data.length < 40) {
          this.noMore = true;
        }

      }
      );
    },
    updateImageOrVideo(data) {
      let arr = [];
      arr.push(data);
      let images = this.convertData(arr);
      this.images.unshift(...images);
    }
  },
  mounted() {
    this.$bus.$on("updateImageOrVideoTab", (data) => this.updateImageOrVideo(data));
  },
  beforeDestroy() {
    this.$bus.$off("updateImageOrVideoTab");
  }
};
</script>
<style scoped>
.vib-thumbnail-image {
  background-position: center;
  background-size: cover;
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px hsla(0, 0%, 100%, .2);
  cursor: pointer;
  display: inline-block;
  margin: 1px 1px 0 1px;
  overflow: hidden;
  z-index: 0;
}
</style>